// import React, { useState } from 'react';
// import Box from '@mui/material/Box';
// import SwipeableDrawer from '@mui/material/SwipeableDrawer';
// import { Divider, Grid, IconButton, Typography } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import FullscreenIcon from '@mui/icons-material/Fullscreen';
// import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
// import { WSIcons } from '../../commonFunctions/iIcons';

// type Anchor = 'top' | 'left' | 'bottom' | 'right';

// type SwipeableDrawerFormProps = {
//   id?:String;
//   anchor?: Anchor;
//   formComponent?: React.ReactNode;
//   openForm?: boolean;
//   onClose?: () => void;
//   title?: string;
//   isMobile?:boolean;
//     isEdit?: boolean;

// };

// const SwipeableDrawerForm: React.FC<SwipeableDrawerFormProps> = ({
//   id,
//   anchor = 'left',
//   formComponent,
//   openForm = false,
//   onClose,
//   title = 'Drawer Form',
//   isMobile=false,
//   isEdit = false
// }) => {
//   const [open, setOpen] = React.useState(openForm);
//   const [isMaximized, setIsMaximized] = useState(false);

//   React.useEffect(() => {
//     setOpen(openForm);
//   }, [openForm]);

//   const toggleDrawer = (isOpen: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
//     if (
//       event.type === 'keydown' &&
//       ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')
//     ) {
//       return;
//     }
//     setOpen(isOpen);
//     if (!isOpen && onClose) {onClose()
//       setIsMaximized(false);
//     };
//   };

//   const handleMaximize = () => {
//     setIsMaximized((prev) => !prev);
//   };

//   return (
//    <SwipeableDrawer
//   anchor="right"
//   open={open}
//   onClose={toggleDrawer(false)}
//   onOpen={toggleDrawer(true)}
//   PaperProps={{
//     sx: {
//       width: 540,
//       maxWidth: "100%",
//       marginTop: "88px",
//       height: "calc(100% - 88px)",
//       borderRadius: 0, // 👈 NO border radius
//       backgroundColor: "#fff",
//       boxShadow: "0px 4px 30px rgba(0,0,0,0.18)",
//       display: "flex",
//       flexDirection: "column",
//     },
//   }}
// >
//   {/* TOP BAR */}
//   {}
//   <Box
//     sx={{
//       width: "100%",
//       padding: "12px 16px",
//       borderBottom: "1px solid #E5E5E5",
//       display: "flex",
//       justifyContent: "space-between",
//       alignItems: "center",
//     }}
//   >
//     {/* CLOSE ICON ON LEFT */}
//     <IconButton onClick={() => toggleDrawer(false)({} as any)}>
//       <WSIcons.AiOutlineCloseSquare style={{ color: "#F30909" }} />
//     </IconButton>

//     {/* UPDATE & SAVE BUTTON ON RIGHT */}
// {isEdit ? (
//    <Box
//       component="button"
//       style={{
//         backgroundColor: "#098963",
//         color: "#fff",
//         border: "none",
//         padding: "8px 16px",
//         borderRadius: "27px",
//         fontSize: "14px",
//         cursor: "pointer",
//         fontWeight: 600,
//       }}
//     >
//       {id?"Update & Save":"Save"}
//     </Box>
// ):"" }
 
//   </Box>

//   {/* HEADING ON NEXT LINE (below top bar) */}
//   <Box sx={{ padding: "20px 20px 10px 20px" }}>
//     <Typography
//       sx={{
//         fontSize: "20px",
//         fontWeight: 600,
//         color: "#1A1A1A",
//       }}
//     >
//       {title}
//     </Typography>
//   </Box>

//   {/* FORM CONTENT */}
//   <Box
//     sx={{
//       padding: "0px 20px 20px 20px",
//       overflowY: "auto",
//       flexGrow: 1,
//     }}
//   >
//     {formComponent}
//   </Box>
// </SwipeableDrawer>

//   );
// };

// export default SwipeableDrawerForm;





// import React, { useState } from 'react';
// import Box from '@mui/material/Box';
// import SwipeableDrawer from '@mui/material/SwipeableDrawer';
// import { IconButton, Typography } from '@mui/material';
// import { WSIcons } from '../../commonFunctions/iIcons';

// type Anchor = 'top' | 'left' | 'bottom' | 'right';

// type SwipeableDrawerFormProps = {
//   id?: string;
//   anchor?: Anchor;
//   formComponent?: React.ReactNode;
//   openForm?: boolean;
//   onClose?: () => void;
//   title?: string;
//   isMobile?: boolean;
//   isEdit?: boolean;
// };

// const SwipeableDrawerForm: React.FC<SwipeableDrawerFormProps> = ({
//   id,
//   anchor = 'left',
//   formComponent,
//   openForm = false,
//   onClose,
//   title = 'Drawer Form',
//   isMobile = false,
//   isEdit = false
// }) => {
//   const [open, setOpen] = React.useState(openForm);

//   React.useEffect(() => {
//     setOpen(openForm);
//   }, [openForm]);

//   const toggleDrawer = (isOpen: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
//     if (
//       event.type === 'keydown' &&
//       ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')
//     ) {
//       return;
//     }
//     setOpen(isOpen);
//     if (!isOpen && onClose) {
//       onClose();
//     }
//   };

//   return (
//     <SwipeableDrawer
//       anchor="right"
//       open={open}
//       onClose={toggleDrawer(false)}
//       onOpen={toggleDrawer(true)}
//       PaperProps={{
//         sx: {
//           width: 540,
//           maxWidth: "100%",
//           marginTop: "88px",
//           height: "calc(100% - 88px)",
//           borderRadius: 0,
//           backgroundColor: "#fff",
//           boxShadow: "0px 4px 30px rgba(0,0,0,0.18)",
//           display: "flex",
//           flexDirection: "column",
//         },
//       }}
//     >
//       {/* ✅ FIXED TOP BAR - Save Button WORKS */}
//       <Box
//         sx={{
//           width: "100%",
//           padding: "12px 16px",
//           borderBottom: "1px solid #E5E5E5",
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//         }}
//       >
//         <IconButton onClick={() => toggleDrawer(false)({} as any)}>
//           <WSIcons.AiOutlineCloseSquare style={{ color: "#F30909" }} />
//         </IconButton>

//         {/* ✅ PERFECT SAVE BUTTON */}
//         {isEdit ? (
//           <Box
//             component="button"
//             type="submit"
//             form={id}  // ✅ Links to TechnicianDrawer's form id="technicianAdd"
//             style={{
//               backgroundColor: "#098963",
//               color: "#fff",
//               border: "none",
//               padding: "8px 16px",
//               borderRadius: "27px",
//               fontSize: "14px",
//               cursor: "pointer",
//               fontWeight: 600,
//             }}
//           >
//             Save
//           </Box>
//         ) : ""}
//       </Box>

//       <Box sx={{ padding: "20px 20px 10px 20px" }}>
//         <Typography sx={{ fontSize: "20px", fontWeight: 600, color: "#1A1A1A" }}>
//           {title}
//         </Typography>
//       </Box>

//       <Box sx={{ padding: "0px 20px 20px 20px", overflowY: "auto", flexGrow: 1 }}>
//         {formComponent}
//       </Box>
//     </SwipeableDrawer>
//   );
// };

// export default SwipeableDrawerForm;







import React, { useState } from 'react';
import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { IconButton, Typography } from '@mui/material';
import { WSIcons } from '../../commonFunctions/iIcons';

type Anchor = "top" | "left" | "bottom" | "right";

type SwipeableDrawerFormProps = {
  id?: string;
  anchor?: Anchor;
  formComponent?: React.ReactNode;
  openForm?: boolean;
  onClose?: () => void;
  title?: string;
  isMobile?: boolean;
  isEdit?: boolean;
  // For read-only drawers (e.g. notifications) that have nothing to save
  hideSaveButton?: boolean;
};

const SwipeableDrawerForm: React.FC<SwipeableDrawerFormProps> = ({
  id,
  anchor = "left",
  formComponent,
  openForm = false,
  onClose,
  title = 'Drawer Form',
  isMobile = false,
  isEdit = false,
  hideSaveButton = false
}) => {
  const [open, setOpen] = React.useState(openForm);

  React.useEffect(() => {
    setOpen(openForm);
  }, [openForm]);

  const toggleDrawer = (isOpen: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }
    setOpen(isOpen);
    if (!isOpen && onClose) {
      onClose();
    }
  };

  return (
    <SwipeableDrawer
      anchor="right"
      open={open}
      onClose={toggleDrawer(false)}
      onOpen={toggleDrawer(true)}
      PaperProps={{
        sx: {
          width: 540,
          maxWidth: "100%",
          marginTop: "88px",
          height: "calc(100% - 88px)",
          borderRadius: 0,
          backgroundColor: "#fff",
          boxShadow: "0px 4px 30px rgba(0,0,0,0.18)",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      {/* ✅ FIXED TOP BAR - Save Button SHOWS FOR BOTH Add & Edit */}
      <Box
        sx={{
          width: "100%",
          padding: "12px 16px",
          borderBottom: "1px solid #E5E5E5",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <IconButton onClick={() => toggleDrawer(false)({} as any)}>
          <WSIcons.AiOutlineCloseSquare style={{ color: "#F30909" }} />
        </IconButton>

        {/* ✅ SAVE BUTTON - visible unless the drawer has nothing to save */}
        {!hideSaveButton && <Box
          component="button"
          type="submit"
          form={id}  // Links to form id="technicianAdd"
          style={{
            backgroundColor: "#098963",
            color: "#fff",
            border: "none",
            padding: "8px 16px",
            borderRadius: "27px",
            fontSize: "14px",
            cursor: "pointer",
            fontWeight: 600,
          }}
        >
          {isEdit ? 'Update' : 'Save'}
        </Box>}
      </Box>

      <Box sx={{ padding: "20px 20px 10px 20px" }}>
        <Typography sx={{ fontSize: "20px", fontWeight: 600, color: "#1A1A1A" }}>
          {title}
        </Typography>
      </Box>

      <Box sx={{ padding: "0px 20px 20px 20px", overflowY: "auto", flexGrow: 1 }}>
        {formComponent}
      </Box>
    </SwipeableDrawer>
  );
};

export default SwipeableDrawerForm;
